export default {
    fleetModalUpdateUnit_unit: "Unit",
    fleetModalUpdateUnit_asset: "Asset",
    fleetModalUpdateUnit_inputOutput: "Input-Output",
    fleetModalUpdateUnit_notes: "Notes",
    fleetModalUpdateUnit_tags: "Tags",
    fleetModalUpdateUnit_assetType: "Type",
    fleetModalUpdateUnit_assetSubType: "SubType",
    fleetModalUpdateUnit_licensePlate: "License Plate",
    fleetModalUpdateUnit_registrationCountry: "Registration Country",
    fleetModalUpdateUnit_registrationState: "Registration State",
    fleetModalUpdateUnit_registrationExpiration: "Registration Expiration Date",
    fleetModalUpdateUnit_vin: "VIN",
    fleetModalUpdateUnit_make: "Make",
    fleetModalUpdateUnit_model: "Model",
    fleetModalUpdateUnit_year: "Year",
    fleetModalUpdateUnit_engineLiters: "Engine Liters",
    fleetModalUpdateUnit_highway: "Highway",
    fleetModalUpdateUnit_city: "City",
    fleetModalUpdateUnit_inspectionDeviceType: "Inspection Device Type",
    fleetModalUpdateUnit_inspectionTagID: "Inspection Tag ID",
    fleetModalUpdateUnit_isELDEnabled: "Is ELD Enabled",
    fleetModalUpdateUnit_powerUnitNumber: "Power Unit Number",
    fleetModalUpdateUnit_toogle: "Toggle On/Off",
    fleetModalUpdateUnit_pulse: "Pulse On/Off",
    fleetModalUpdateUnit_single: "Single Pulse",
    fleetModalUpdateUnit_inputLabel: "Input Label",
    fleetModalUpdateUnit_outputLabels: "OUTPUT Labels",
    fleetModalUpdateUnit_outputLabels: "Output Label",
    fleetModalUpdateUnit_notes: "Notes",
    fleetModalUpdateUnit_tagsLabel: "This unit belongs to the following tags:",
    fleetModalUpdateUnit_addTags: "Add Tags",
    fleetModalUpdateUnit_tags: "Tags",
    fleetModalUpdateUnit_decodeVin: "Decode VIN",
    fleetModalUpdateUnit_maxValue: "Max value",
    fleetModalUpdateUnit_minValue: "Min value",
    fleetModalUpdateUnit_unitLabelAndIcon: "Unit Label and Icon Type",
    fleetModalUpdateUnit_enableAndDisabled: "Enable All / Disabled All",
    fleetModalUpdateUnit_disabled: "Disabled All",
    fleetModalUpdateUnit_enable: "Enable All",
    fleetModalUpdateUnit_speed: "Speed",
    fleetModalUpdateUnit_calculatedByEcu: "Calculated by ECU",
    fleetModalUpdateUnit_calculatedByGps: "Calculated by GPS",
    fleetModalUpdateUnit_odometer: "Odometer",
    fleetModalUpdateUnit_dashReading: "Dash Reading",
    fleetModalUpdateUnit_lastUpdated: "Last update",
    fleetModalUpdateUnit_engineHours: "Engine Hours",
    fleetModalUpdateUnit_actual: "Actual",
    fleetModalUpdateUnit_assignedDriver: "Assigned Driver",
    fleetModalUpdateUnit_defaultDriver: "Default Driver",
    fleetModalUpdateUnit_driverDefaultInfo: `The primary driver will be automatically assigned as the "Assigned Driver" when the vehicle is in motion without an assigned driver. Driver assignment will be based on the value set in the "Default Driver" field.`,
    fleetModalUpdateUnit_location: "Location",
    fleetModalUpdateUnit_timezone: "Timezone",
    fleetModalUpdateUnit_consistentSpeed: "Consistent Speed",
    fleetModalUpdateUnit_custom: "Custom",
    fleetModalUpdateUnit_duplicatedLabel: "Label is already in use",
    fleetModalUpdateUnit_duplicatedlicensePlace: "License Plate is already in use",
    fleetModalUpdateUnit_duplicatedVin: "VIN is already in use",
    fleetModalUpdateUnit_errorVin: "Invalid VIN, must have 17 alphanumeric characters, no I, O or Q, no special characters or spaces, and with a valid check digit in the ninth position",
    fleetModalUpdateUnit_warningVinCheckDigit: "VIN decoded, but its check digit (9th position) is incorrect, so the data may be inaccurate. Please verify the VIN; it may be rejected when saving.",
    fleetModalUpdateUnit_successMessage: "Unit was updated successfully",
    fleetModalUpdateUnit_duplicatedTagId: "Inspection Tag ID is already in use",
    fleetModalUpdateUnit_status: "Status",
    fleetModalUpdateUnit_enterExternalId: "Enter External ID",
    fleetModalUpdateUnit_none: "None",
    fleetModalUpdateUnit_requiredFields: "All required fields must be completed and contain valid values to proceed",
    fleetModalUpdateUnit_alert_title: "Validation Error",
    fleetModalUpdateUnit_licensePlateErrorLength: "License Plate must be between 4 and 20 characters",
    
    fleetModalUpdateUnit_maintenanceCompany_none: "No Maintenance Company",
    fleetModalUpdateUnit_maintenanceCompany_idealease: "Idealease",
    fleetModalUpdateUnit_maintenanceCompany_nationalease: "Nationalease",
    fleetModalUpdateUnit_maintenanceCompany_noregon: "Noregon",
    fleetModalUpdateUnit_maintenanceCompany_penske: "Penske",
    fleetModalUpdateUnit_maintenanceCompany_ryder: "Ryder",
    fleetModalUpdateUnit_maintenanceCompany_other: "Other Maintenance Company",
    fleetModalUpdateUnit_labelEmpty: "Unit label cannot be empty",
}